import React, { useEffect } from 'react';
import { Link } from "react-router";
import '../styles/Version.css';

const Version: React.FC = () => {
  useEffect(() => {
    document.title = 'Build info | Atlanta Executive Property Management';
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);
    return () => {
      document.head.removeChild(robots);
    };
  }, []);

  const rows: { label: string; value: string }[] = [
    { label: 'Version', value: import.meta.env.REACT_APP_VERSION || 'dev' },
    { label: 'Commit', value: import.meta.env.REACT_APP_COMMIT || 'unknown' },
    { label: 'Built at', value: import.meta.env.REACT_APP_BUILD_DATE || 'unknown' },
  ];

  return (
    <div className="version-page">
      <div className="version-card">
        <h1>Build info</h1>
        <p className="brand">Atlanta Executive Property Management</p>
        <dl>
          {rows.map((row) => (
            <div className="version-row" key={row.label}>
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
        <Link to="/" className="back-link">&larr; Back to home</Link>
      </div>
    </div>
  );
};

export default Version;
